import CardItem from "pages/ManagementPage/CardItem/CardItem";

export default CardItem;
